<template>
  <div>
    <Modal v-model="Batchnew" title="批量新增商品" footer-hide width="500px">
      <a
        href="https://img.g-part.cn/test/oms/2021/12/23/16402222589973963.xlsx"
        class="abq"
        >下载模板</a
      >
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="90"
      >
        <FormItem label="上传文件:" prop="uploading">
          <Row>
            <div class="updatadq">
              <Input
                v-model="formValidate.uploading"
                style="width:300px;margin-right:10px"
              ></Input>
              <Col>
                <Upload
                  :show-upload-list="false"
                  action=""
                  :on-success="uploading"
                  :before-upload="handleUpload"
                >
                  <Button style="color:#fff;background-color:#0074ff;border:none">浏览</Button>
                </Upload>
              </Col>
            </div>
          </Row>
        </FormItem>
        <div v-if="renewalresult">
          <p class="fz14" style="padding-left:10px"><b>批量新增结果:</b></p>
          <p class="fz14" style="padding-left:10px">
            总计<span>{{ total1 }}</span
            >行
          </p>
          <p class="fz14" style="padding-left:10px">
            新增成功<span>{{ succeed }}</span
            >行
          </p>
          <p class="fz14" style="padding-left:10px">
            新增失败<span>{{ loser }}</span
            >行
            <!-- <span class="exportlose">(请导出更新失败商品清单)</span> -->
            <a class="a1" :href="loseinventory">请导出新增失败商品清单</a>
          </p>
        </div>
          <div style="width:100%;text-align: center;margin-top:20px">
          <Button
            style="background-color:#377CF1;color:#fff;border:none;margin-right:20px"
            :loading="loading"
            @click="handleSubmit('formValidate')"
            >批量新增</Button
          >
          <Button @click="handleReset('formValidate')" style="margin-left:20px"
            >关闭</Button
          >
          </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
// import Cookies from 'js-cookie' // Cookies的来源
// import { TOKEN_KEY } from '@/libs/util' // TOKEN_KEY的值
// import urlObj from '@/config/env.js' // 以后就导入这个url对象就好了
import { batchappend } from '@/api/myweb/goods/components/goodsBatch'
// import urlObj from '@/config/env.js' // 环境
export default {
  data() {
    return {
      // token: Cookies.get(TOKEN_KEY), // 拿到token
      Batchnew: false, // 批量新增的弹框
      renewalresult: false, // 更新的结果
      // bulkport: urlObj.wss, // 是走的那个环境
      // 表单
      formValidate: {
        uploading: ''
      },
      // 规则
      ruleValidate: {
        uploading: [
          {
            required: true,
            message: '请上传文件',
            trigger: 'blur'
          }
        ]
      },
      file: null, // 阻止上传
      total1: null, // 总的上传
      succeed: null, // 成功的上传
      loser: null, // 失败的上传
      loseinventory: '', // 失败之后的地址的
      // uploadingsite: 'http://192.168.0.123:5000/wss-part/partsBatch/savePartsBatch`${}`' // 上传的地址的
      loading: false // 转圈
    }
  },
  methods: {
    // 批量新增
    handleSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          this.loading = true
          console.log(this.file)
          let fd = new FormData()
          fd.append('file', this.file)
          const res = await batchappend(fd)
          console.log(res)
          if (res.code == 0) {
            this.loading = false
            this.renewalresult = true
            this.total1 = res.data.total
            this.succeed = res.data.succeed
            this.loser = res.data.loser
            this.loseinventory = res.data.filePath
            this.$Message.destroy()
            this.$Message.success(res.message)
            this.$emit('refush')
          } else {
            this.loading = false
          }
        }
      })
    },
    // 关闭
    handleReset(name) {
      this.$refs[name].resetFields()
      this.Batchnew = false
    },
    // 打开
    openBatch() {
      this.$refs.formValidate.resetFields()
      this.Batchnew = true
      this.renewalresult = false
    },
    // 成功之后调用的钩子
    uploading(file) {
      if (file.code == 0) {
        this.$Message.success(file.message)
      } else {
        this.$Message.error(file.message)
      }
      console.log(file)
    },
    // 文件上传之前得钩子
    handleUpload(file) {
      console.log(file)
      this.formValidate.uploading = file.name
      this.file = file
      return false
    }
  }
}
</script>

<style lang="less" scoped>
.abq {
  color: #0074ff;
  display: inline-block;
  margin-bottom: 20px;
  padding-left: 10px;
}
.updatadq {
  display: flex;
}
.a1 {
  color: #0074ff;
}

/deep/ .ivu-form-item-label{
  text-align: left;
}
</style>
